import { useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Sidepanel from 'modules/core/components/Sidepanel'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { NewAssignmentCard } from 'modules/finance/components/CostCenterAssigments/Assigments/NewAssignmentCard'
import useCostCentersAssignments from 'modules/finance/hooks/useCostCentersAssignments'

import { Content } from './components/Content'
import { Loading } from './components/Loading'

interface AssigmentsProps {
  legalEntityIds: number[]
  resourceId: number
}

interface Props extends AssigmentsProps {
  open: boolean
  title: string
  withAssignmentIdOpened?: number
  onClose: () => void
  onDelete?: () => void
  onSubmit?: () => void
}

export const CostCenterAssignmentsSidepanel = ({
  legalEntityIds,
  open,
  resourceId,
  title,
  withAssignmentIdOpened,
  onClose,
  onDelete,
  onSubmit,
}: Props) => {
  const [newAssignment, setNewAssignment] = useState(false)
  const [showNewAssignmentButton, setShowNewAssignmentButton] = useState(true)
  const [isEditing, setIsEditing] = useState(false)

  const { isLoading, canManageCostCenterMemberships, assignments, refetch } =
    useCostCentersAssignments({
      resourceId,
      skipQueries: !open,
    })

  const handleAction = async () => {
    return await refetch()
  }

  const addNewAssignment = () => {
    setNewAssignment(true)
    setShowNewAssignmentButton(false)
    track(trackingEvents.accounting.newCostcenterAssignmentStarted)
  }

  const handleDelete = async () => {
    await handleAction()

    onDelete?.()
  }

  const handleSubmit = async () => {
    await handleAction()

    onSubmit?.()
  }

  const handleClose = () => {
    setNewAssignment(false)
    setShowNewAssignmentButton(true)
    onClose()
  }

  return (
    <Sidepanel
      overlay={false}
      width="wide"
      title={title}
      onClose={handleClose}
      open={open}
      footer={
        canManageCostCenterMemberships &&
        !isEditing &&
        showNewAssignmentButton && (
          <Button type="secondary" iconName="add" onClick={addNewAssignment}>
            {i18n.t('finance.cost_centers.assignments.new_assignment_card.title')}
          </Button>
        )
      }
      headerBorder
    >
      {isLoading && <Loading />}
      {!isLoading && (
        <Box gap="s24">
          <Content
            assignments={assignments}
            legalEntityIds={legalEntityIds}
            resourceId={resourceId}
            withAssignmentIdOpened={withAssignmentIdOpened}
            canManageCostCenterMemberships={canManageCostCenterMemberships}
            onCancel={onClose}
            onDelete={handleDelete}
            onSave={handleSubmit}
            onToggleEdit={(value: boolean) => setIsEditing(value)}
          >
            {canManageCostCenterMemberships && newAssignment && (
              <NewAssignmentCard
                allAssignments={assignments}
                legalEntityIds={legalEntityIds}
                resourceId={resourceId}
                onCancel={() => {
                  setNewAssignment(false)
                  setShowNewAssignmentButton(true)
                }}
                onSave={() => {
                  handleSubmit()
                  setNewAssignment(false)
                  setShowNewAssignmentButton(true)
                }}
              />
            )}
          </Content>
        </Box>
      )}
    </Sidepanel>
  )
}
